import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import ItemShow from './ItemShow';
import '../GamePage/GamePage.css';

const ShowPage = (props) => {
    let sWords = props.textGame.map((items, index) =>
        <ItemShow key={items} id={index} place={props.answers[index]} historyAnswers={props.historyAnswers[props.answers[index]]} className={'wordsPlace Place' + props.answers[index]} value={items} classButton={'YesNo Place' + props.answers[index]} tasksGame={props.tasksGame} />
    );


    return (
        <div>
            <img src={props.bgSrc} className='bigBg' alt=' ' />
            <img src={props.src} className='gameImgSmall' alt=' ' />
            <img src={props.placeSrc} className='textPlace' alt=' ' />
            <img src={props.nameSrc} className='nameHoliday' alt=' ' />
            <div className='Tasks' >  <Text value={props.tasksGame.first[props.stepQuestion]} /> <Text value={props.tasksGame.second} /> </div>
            <Text className='GameQuestion' value={props.tasksGame.questions[props.stepQuestion]} />
            {sWords}
            <div className='countPlace'> </div>
            <Text className='count' value= '4 - 4' />

            <Button className='GamePrev' onClick={() => props.onClick('prev','show')} hidden={props.hiddenPrev} /> 
            <Button className='ShowNext' onClick={() => props.onClick('ShowNext')} /> 
        </div>
    );
    };

export default ShowPage; 